module.exports = require("core-js/modules/esnext.set.is-superset-of.js");